import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Button, Divider } from "@material-ui/core";
import NewTicketWithQueueModal from "../AcceptTicketWithQueueModal";

const VcardPreview = ({ contact, numbers }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });
    const [loading, setLoading] = useState(false);
    const [queueModalOpen, setQueueModalOpen] = useState(false);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    const contactObj = {
                        name: contact,
                        number: numbers !== undefined && numbers.replace(/\D/g, ""),
                        email: ""
                    };
                    const { data } = await api.post("/contact", contactObj);
                    setContact(data);
                } catch (err) {
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [contact, numbers]);

    const handleNewChat = async () => {
        if (!selectedContact.id) return;
        setLoading(true);
        try {
            // Check for existing open or pending ticket
            const { data } = await api.get(`/tickets/contact/${selectedContact.id}/open`);
            if (data.ticket) {
                history.push(`/tickets/${data.ticket.id}`);
                return;
            }
            // No open ticket — ask for queue
            setQueueModalOpen(true);
        } catch (err) {
            toastError(err);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateWithQueue = async (queueId) => {
        setLoading(true);
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
                queueId,
            });
            setQueueModalOpen(false);
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div style={{ minWidth: "250px" }}>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Avatar src={selectedContact.profilePicUrl} />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
                            {selectedContact.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!selectedContact.number || loading}
                        >
                            {loading ? <CircularProgress size={20} /> : "Conversar"}
                        </Button>
                    </Grid>
                </Grid>
            </div>

            <NewTicketWithQueueModal
                open={queueModalOpen}
                onClose={() => setQueueModalOpen(false)}
                onConfirm={handleCreateWithQueue}
                loading={loading}
            />
        </>
    );
};

export default VcardPreview;
